// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class TerminalShopWindowsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicTerminalShopWindows';
        this.Server =
            this.props.context.getState().server.publicTerminalShopWindows;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'name',
            'description',
            'url',
            'terminalGateway.gateway.name'
        ];

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'terminalGatewayId',
                label: 'terminalGateway',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                object: 'terminalGateway',
                from: 'publicGateways',
                nestedObject: 'gateway',
                show: 'name',
                filterField: 'terminalGateway.gateway',
                displayDialogDetails: true
            },
            {
                id: 'url',
                label: 'url',
                alignRight: false,
                cell: 'Url',
                displayGrid: true
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName',
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
